var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBcpRound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 38.833c10.125 0 18.333-8.208 18.333-18.333 0-10.125-8.208-18.333-18.333-18.333-10.125 0-18.333 8.208-18.333 18.333 0 10.125 8.208 18.333 18.333 18.333Zm0 1.667c11.046 0 20-8.954 20-20S31.046.5 20 .5 0 9.454 0 20.5s8.954 20 20 20Z",
    fill: "#E7EAEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.604 26.121-4.325-10.294c-1.347-3.164-3.242-4.458-4.746-4.823-.671-.236-2.617-.076-2.617-.076s1.467.076 2.272.694c1.126.747 1.827 2.495 1.515 4.86l-1.371 10.292c-.184 1.261-.55 3.34-.55 3.34h1.969s.123-1.589.306-3.013l1.313-10.037 4.371 10.528c.552 1.307.874 1.938 2.024 2.825L25.92 17.04l1.312 11.252c.075.795.132 1.822.132 1.822h2.553s-.223-1.355-.362-2.452L28.035 16.2c-.046-.537-.107-1.447-.107-1.447h-3.16v.023c0 .49-.161.957-.345 1.448l-3.82 9.897Z",
    fill: "#D1005D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBcpRound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bcpRound.cfe8622a42de726d96f23914903bbd97.svg";